module.exports = __webpack_public_path__ + "img/yuumi.8a0255e9.jpg";